/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import "cropperjs/dist/cropper.css";
import { TbArrowBackUp } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";
import { SectionCard } from "@/Pages/Influencer/PublicProfile/Component";
import {
  ProfileForm,
  ContentForm,
  AudienceDataForm,
  CollabForm,
  MonetizationForm,
  ChargesForm,
  TopLinksForm,
  TopLinksPreview,
} from "./BuildProfileForms";
import { useBuildProfileHooks } from "./BuildProfileHooks";
import { useAuth } from "../../../../Providers/Auth";
import mixpanel from "mixpanel-browser";
import { Eye } from "lucide-react";

const BuildProfile: React.FC = () => {
  const navigate = useNavigate();
  const authState = useAuth();

  const {
    currentPage,
    setCurrentPage,
    profileData,
    setProfileData,
    profileFormImages,
    setProfileFormImages,
    contentData,
    setContentData,
    audienceData,
    setAudienceData,
    collabData,
    setCollabData,
    // formTwoImages,
    // setFormTwoImages,
    monetizationData,
    setMonetizationData,
    chargesData,
    setChargesData,
    topLinksData,
    setTopLinksData,
    handleSubmit,
    errorArray,
    loading,
  } = useBuildProfileHooks();

  return (
    <>
      <MobileMenuBar />
      <div className="md:hidden w-full px-4 py-[13px] md:w-auto absolute top-0 md:static z-50 border-b-neutral-800 border-b border-solid md:border-none bg-[#171717] md:bg-none flex  items-center justify-between md:items-start gap-[8px] ">
        <TbArrowBackUp
          onClick={() => navigate("/influencer/dashboard")}
          color="#EEEEEE"
          size={24}
        />
        <div className="flex flex-col items-center">
          <h1 className="text-[14px] text-[#FFFFFF]  md:text-[24px] font-[600] font-inter">
            Build Your Profile
          </h1>
          <span className="text-[12px] md:text-[14px] font-[400] text-[#A3A3A3] font-inter">
            🕓 Set up takes 7 mins on average
          </span>
        </div>
        {/* <div className="h-1 w-1"></div> */}
        {!authState?.loggedUser?.activePlan ? (
          <Eye
            size={24}
            color="#EEEEEE"
            onClick={() => {
              mixpanel.track(
                "Influencer Dashboard : Preview Profile : clicked"
              );
              navigate(`/influencer/edit/?mode=preview`);
            }}
          />
        ) : (
          <div className="h-1 w-1"></div>
        )}
      </div>
      <div
        id="remainingPage"
        className="w-full pb-[100px] px-4 py-5 md:px-10 md:py-5 box-border flex flex-col md:flex-row h-max relative"
      >
        {!loading ? (
          <div className="h-full flex flex-col items-start w-full md:w-[75%]  text-[#FFFFFF] justify-center gap-[46px] bg-[#171717]">
            <div className="hidden md:block w-full md:w-auto absolute top-0 md:static z-10 border-b-neutral-800 border-b border-solid md:border-none bg-[#171717] md:bg-none flex flex-col items-center md:items-start gap-[8px] ">
              <h1 className="text-[14px] md:text-[24px] font-[600] font-inter">
                Build Your Profile
              </h1>
              <span className="text-[12px] md:text-[14px] font-[400] text-[#A3A3A3] font-inter">
                🕓 Set up takes 7 mins on average
              </span>
            </div>
            {currentPage === "profile" && (
              <>
                <ProfileForm
                  data={profileData}
                  setData={setProfileData}
                  formOneImages={profileFormImages}
                  setFormOneImages={setProfileFormImages}
                  onSubmit={() => handleSubmit({ noNavigate: false })}
                />
              </>
            )}
            {currentPage === "content" && (
              <>
                <ContentForm
                  data={contentData}
                  setData={setContentData}
                  onSubmit={() => handleSubmit({ noNavigate: false })}
                />
              </>
            )}
            {currentPage === "audience" && (
              <>
                <AudienceDataForm
                  data={audienceData}
                  setData={setAudienceData}
                  onSubmit={() => handleSubmit({ noNavigate: false })}
                  onClick={() => setCurrentPage("collab")}
                />
              </>
            )}
            {currentPage === "collab" && (
              <>
                <CollabForm
                  data={collabData}
                  setData={setCollabData}
                  // formTwoImages={formTwoImages}
                  // setFormTwoImages={setFormTwoImages}
                  errorArray={errorArray}
                  onSubmit={({ noNavigate }) => handleSubmit({ noNavigate })}
                />
              </>
            )}
            {currentPage === "monetization" && (
              <>
                <MonetizationForm
                  data={monetizationData}
                  setData={setMonetizationData}
                  errorArray={errorArray}
                  onSubmit={({ noNavigate }) => handleSubmit({ noNavigate })}
                />
              </>
            )}
            {currentPage === "pricing" && (
              <>
                <ChargesForm
                  data={chargesData}
                  setData={setChargesData}
                  onSubmit={() => handleSubmit({ noNavigate: false })}
                  onClick={() => navigate("/influencer/payment")}
                />
              </>
            )}
            {currentPage === "toplinks" && (
              <>
                <TopLinksForm
                  data={topLinksData}
                  setData={setTopLinksData}
                  onSubmit={() => handleSubmit({ noNavigate: false })}
                />
              </>
            )}
          </div>
        ) : (
          // loader
          <div className="w-full flex flex-col items-center justify-center h-full"></div>
        )}

        {/* ------- right side panel --------- */}
        <div className="h-full flex flex-col items-start w-full md:w-[30%]  text-[#FFFFFF] justify-center gap-[46px] bg-[#171717]">
          {currentPage === "toplinks" && (
            <>
              <div className="hidden w-full md:flex gap-5 flex-col sticky top-5 px-5">
                <div className="size-full flex flex-col gap-5">
                  <SectionCard
                    icon={"📌"}
                    title="My Top Links"
                    subtitle="Links to my top social media profiles & websites"
                  >
                    <div className="flex items-start flex-wrap gap-4">
                      <TopLinksPreview data={topLinksData} />
                    </div>
                  </SectionCard>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default BuildProfile;
